// eslint-disable-next-line react-refresh/only-export-components -- NPS is a valid component name
export { NPS, type NPSProps } from './NPS'
